function insertBundlePrompts() {

  const cartContainer = document.querySelector('cart-drawer') || document.querySelector('.cart');
  if (!cartContainer || !window.theme || !window.theme.bundleSettings) {
    return;
  }

  const bundleRows = cartContainer.querySelectorAll('.bundle-eligible');
  const bundles = {};

  bundleRows.forEach(row => {
    const productId = row.dataset.productId;
    if (!productId) return;

    const quantityInput = row.querySelector('quantity-selector input');
    const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 0;

    if (isNaN(quantity)) {
      return;
    }

    if (!bundles[productId]) {
      bundles[productId] = {
        quantity: 0,
        is_promo: row.dataset.bundleType === 'promo'
      };
    }
    bundles[productId].quantity += quantity;
  });

  Object.keys(bundles).forEach(productId => {
    const { quantity, is_promo } = bundles[productId];
    const rows = cartContainer.querySelectorAll(`.bundle-eligible[data-product-id="${productId}"]`);

    rows.forEach(row => {
      const upsellTextEl = row.querySelector('.bundle-upsell-text');
      if (upsellTextEl) upsellTextEl.innerHTML = '';
    });

    const discounts = is_promo ? window.theme.bundleSettings.promo_discounts : window.theme.bundleSettings.standard_discounts;

    const upsellTiers = Object.keys(discounts)
      .map(qty => ({ qty: parseInt(qty, 10), discount: discounts[qty] }))
      .filter(item => item.discount > 0)
      .sort((a, b) => a.qty - b.qty);

    let message = '';

    const closestQuantityTier = upsellTiers.find(tier => tier.qty > quantity);

    if (closestQuantityTier) {
      const quantityToAdd = closestQuantityTier.qty - quantity;
      const discountMessage = `${closestQuantityTier.discount}%`;
      message = `Add ${quantityToAdd} more to get ${discountMessage} off!`;
    }

    rows.forEach(row => {
      const upsellEl = row.querySelector('.bundle-upsell');
      if (!upsellEl) return;

      upsellEl.hidden = message === '';
      const upsellTextEl = upsellEl.querySelector('.bundle-upsell-text');
      if (upsellTextEl) {
        upsellTextEl.textContent = message;
      }
    });
  });
}

/**
 * Initializes the bundle prompt functionality.
 * It runs on initial page load and listens for cart updates.
 */
function initCartBundlePrompts() {
  // Run on initial load for the main cart page.
  insertBundlePrompts();

  // The cart drawer's content is dynamically replaced.
  // The `cart-drawer:refreshed` event is dispatched after its content is updated.
  document.addEventListener('cart-drawer:refreshed', insertBundlePrompts);
}

// Wait for the DOM to be fully loaded before initializing.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCartBundlePrompts);
} else {
  initCartBundlePrompts();
}